import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.scss'],
    standalone: false
})
export class DialogConfirmComponent {
  
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

  confirm() {
    this.dialogRef.close(true);
  }
}
